module.exports = __webpack_public_path__ + "1b4f53539963baf0cdaef95f7d217ae2.MP3";